export const INFINITE_DURATION = 4294967296;
